// extracted by mini-css-extract-plugin
module.exports = {"separator":"NftTransactions_separator__3gQ7Y"};